import Pikaday from 'pikaday';

class DateDropdown {
    constructor(el) {
        this.el = el;
        this.toggle = el.querySelector('.dropdown-toggle');
        this.calendarsContainer = el.querySelector('.date-dropdown--calendars');
        this.dateRange = {
            el: el.querySelector('.date-dropdown--option.date-range'),
            radio: el.querySelector('#date-option--range'),
            active: el.querySelector('#date-option--range').checked
        }
        // handle form reset
        this.parentForm = this.dateRange.radio.form;
        this.parentForm.onreset = () => {
            this.reset();
        };
        // attach pikaday to date from/to fields
        this.input_From = el.querySelector('input[data-date-picker-from]');
        this.input_To = el.querySelector('input[data-date-picker-to]');
        this.dateFrom = null;
        this.dateTo = null;
        let _this = this;
        this.dateFromPicker = new Pikaday({
            field: _this.input_From,
            container: _this.calendarsContainer,
            firstDay: 1,
            minDate: new Date(),
            format: 'DD-MM-YYYY',
            onOpen: function() {
                _this.toggleRange(true);
            },
            onSelect: function() {
                _this.dateFrom = this.getDate();
                _this.updateDatePickers();
                _this.dateFromPicker.hide();
                _this.dateToPicker.show();
            }
        });
        this.dateToPicker = new Pikaday({
            field: _this.input_To,
            container: _this.calendarsContainer,
            firstDay: 1,
            minDate: new Date(),
            format: 'DD-MM-YYYY',
            onOpen: function() {
                _this.toggleRange(true);
            },
            onSelect: function() {
                _this.dateTo = this.getDate();
                _this.updateDatePickers();
            }
        });
        // link radiobuttons and date-range areas to show active
        this.otherOptions = el.querySelectorAll('.date-dropdown--option:not(.date-range) input[type="radio"]');
        this.otherOptions.forEach(o => {
            o.onclick = () => {
                _this.toggleRange(false);
                _this.updateToggleText(o.dataset.label);
            }
        });
        this.input_From.onchange = () => {
            _this.toggleRange(true);
        }
        this.input_To.onchange = () => {
            _this.toggleRange(true);
        }
    }

    toggleRange(active) {
        if(active && !this.dateRange.active) {
            this.dateRange.el.classList.add('active');
            this.dateRange.radio.checked = true;
            this.dateRange.radio.setAttribute('checked','checked');
            this.dateRange.active = true;
            this.otherOptions.forEach(o => {
                o.removeAttribute('checked');
                o.checked = false;
            });
        } else if(!active && this.dateRange.active) {
            this.dateRange.el.classList.remove('active');
            this.dateRange.radio.removeAttribute('checked');
            this.dateRange.radio.checked = false;
            this.dateRange.active = false;
        }
    }

    updateDatePickers() {
        // from
        this.dateFromPicker.setStartRange(this.dateFrom);
        this.dateFromPicker.setEndRange(this.dateTo);
        this.dateFromPicker.setMaxDate(this.dateTo);
        // to
        this.dateToPicker.setStartRange(this.dateFrom);
        this.dateToPicker.setEndRange(this.dateTo);
        this.dateToPicker.setMinDate(this.dateFrom);
        // toggle label
        this.updateToggleText(`${this.dateFromPicker.getMoment().format('D MMM YYYY')} - ${this.dateToPicker.getMoment().format('D MMM YYYY')}`);
    }

    updateToggleText(newText) {
        this.toggle.innerHTML = newText;
    }

    reset() {
        this.toggleRange(false);
        this.otherOptions[0].checked = true;
        this.otherOptions[0].setAttribute('checked','checked');
        this.updateToggleText(this.otherOptions[0].dataset.label);
    }

}

export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new DateDropdown(node);
        }
    });
}